// extracted by mini-css-extract-plugin
module.exports =  {"layer":"_2787e5dfdf--layer--MY1EC","icon":"_2787e5dfdf--icon--N9gq8","large":"_2787e5dfdf--large--wr946","extra-large":"_2787e5dfdf--extra-large--IK9gR"};